module.exports = __webpack_public_path__ + "media/video_comercial_reducido.8c50a361.mp4";